import { render } from "./ArrowForward.vue?vue&type=template&id=c89021fc"
const script = {}
script.render = render

export default script